
import html5 from '../assets/images/SVG/html5.svg'
import sass from '../assets/images/SVG/sass.svg'
import javascript from '../assets/images/SVG/javascript.svg'
import ReactLogo from '../assets/images/SVG/react.svg'
import next from '../assets/images/SVG/next.svg'
import blender from '../assets/images/SVG/blender.svg'
import strapi from '../assets/images/SVG/strapi.svg'
import ai from '../assets/images/SVG/ai.svg'
import ps from '../assets/images/SVG/ps.svg'
import xd from '../assets/images/SVG/xd.svg'
import figma from '../assets/images/SVG/figma.svg'

export default function CarrouselLogos() {
  return (
    <div className='d-flex items-logos'>
        <img
        src={ai}
        height={`34em`}
        alt="illustrator"
        className="mr-5"
        />

        <img
        src={ps}
        height={`34em`}
        alt="photoshop"
        className="mr-5"
        />

        <img
        src={xd}
        height={`34em`}
        alt="Adobe XD"
        className="mr-5"
        />

        <img
        src={figma}
        height={`34em`}
        alt="Figma"
        className="mr-5"
        />

        <img
        src={blender}
        height={`34em`}
        alt="blender"
        className="mr-5"
        />

        <img
        src={html5}
        height={`34em`}
        alt="HTML5"
        className="mr-5"
        />

        <img
        src={sass}
        height={`34em`}
        alt="Sass"
        className="mr-5"
        />

        <img
        src={javascript}
        height={`34em`}
        alt="javascript"
        className="mr-5"
        />

        <img
        src={ReactLogo}
        height={`34em`}
        alt="React"
        className="mr-5"
        />

        <img
        src={next}
        height={`34em`}
        alt="Next.js"
        className="mr-5"
        />

        <img
        src={strapi}
        height={`34em`}
        alt="Strapi"
        className="mr-5"
        />
    </div>
  )
}
